import React from 'react';
import PropTypes from 'prop-types';

const Refresh = ({ color }) => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 14 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path d="M8.36361 12.4548L5.09088 15.7276L8.36361 19.0003" stroke={color} strokeWidth="2" />
    <path
      d="M11.6872 7.13671C12.1899 8.00736 12.4545 8.995 12.4545 10.0003C12.4545 11.0057 12.1899 11.9933 11.6872 12.864C11.1845 13.7346 10.4615 14.4576 9.59089 14.9603C8.72024 15.463 7.7326 15.7276 6.72726 15.7276"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path d="M5.09086 7.54529L8.36359 4.27256L5.09086 0.999833" stroke={color} strokeWidth="2" />
    <path
      d="M1.76725 12.8634C1.26457 11.9928 0.999939 11.0051 0.999939 9.99978C0.999939 8.99443 1.26457 8.0068 1.76725 7.13614C2.26992 6.26549 2.99292 5.54249 3.86358 5.03981C4.73423 4.53714 5.72187 4.27251 6.72721 4.27251"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

Refresh.propTypes = {
  color: PropTypes.string.isRequired,
};

export default Refresh;
